<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/container_scheduled_service.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/components/views/service_provider/services/container_op/container_input.yml"
  lang="yaml"
></i18n>
<template>
  <div class="grid grid-cols-6 gap-x-4 gap-y-6 py-3">
    <div class="col-span-6">
      <label class="block text-sm font-medium text-gray-700">{{
        new_container
          ? $t("labels.new_container")
          : $t("labels.select_container")
      }}</label>
      <div class="flex">
        <div
          v-show="new_container"
          class="grid grid-cols-1 w-full gap-x-4 sm:grid-cols-6"
        >
          <div class="sm:col-span-3 pt-2">
            <label class="label-form">
              {{ $t("model.container.container_code") }}
            </label>
            <div class="mt-1">
              <input
                type="text"
                v-model="container_code"
                :placeholder="$t('model.container.container_code')"
                class="mt-1 focus:ring-[#5c7a2e] focus:border-[#5c7a2e] block w-full shadow-sm sm:text-sm border-slate-300 rounded-md"
              />
            </div>
          </div>
          <div class="sm:col-span-3 pt-2">
            <label class="label-form">
              {{ $t("model.container.agro_exporter_process") }}
            </label>
            <div class="mt-1">
              <select-form
                v-if="agro_exporter_processes.length > 1"
                class="custom-tailwind-select w-full"
                :options="agro_exporter_processes"
                v-model="agro_exporter_process_id"
                label="name"
              />
              <div
                class="content-data w-full"
                v-else-if="agro_exporter_processes.length == 1"
              >
                {{ agro_exporter_processes[0]?.name }}
              </div>
            </div>
          </div>
        </div>
        <select-form
          v-if="containers.length > 1"
          v-show="!new_container"
          class="custom-tailwind-select w-full"
          :options="containers"
          v-model="container_id"
          label="container_code"
        />
        <div class="content-data w-full" v-else-if="containers.length == 1">
          {{ containers[0]?.container_code }}
        </div>

        <button
          class="p-2 flex items-start md:items-center mt-4 md:mt-1"
          @click.prevent="changeMode()"
        >
          <i
            :class="[
              'fa-solid fa-lg pl-1 text-blue-700',
              new_container ? 'fa-minus' : 'fa-plus',
            ]"
          ></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      agro_exporter_process_id:
        this.modelValue?.agro_exporter_process_id ?? null,
      container_code: this.modelValue?.container_code ?? null,
      container_id: this.modelValue?.id ?? null,
      customer_id: null,
      packing_house_id: null,
      new_container: false,
    };
  },
  props: {
    containers: {
      required: true,
    },
    agro_exporter_processes: {
      required: true,
    },
    modelValue: {},
  },
  computed: {
    container: function () {
      return {
        id: this.container_id,
        container_code: this.container_code,
        agro_exporter_process_id: this.agro_exporter_process_id,
      };
    },
  },
  mounted() {
    if (this.container_id == null && this.container?.id) {
      this.container_id = this.container?.id;
    }
    this.setDefaultValue();
  },
  methods: {
    changeMode: function () {
      this.agro_exporter_process_id = null;
      this.container_code = null;
      this.container_id = null;
      this.new_container = !this.new_container;
    },
    setDefaultValue() {
      if (this.containers.length == 1) {
        this.container_id = this.containers[0]?.id;
      }
    },
  },
  watch: {
    container: function (new_value) {
      this.$emit("update:modelValue", new_value);
    },
    containers: {
      handler: function () {
        this.setDefaultValue();
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
